import { RouteItem } from '@eastcoal/router/types/route'

import {
  RANKING_AUCTION_CREATE_PAGE_PATH,
  RANKING_AUCTION_LIST_PAGE_PATH
} from './constants/path'
import { RANKING_AUCTION_LIST_PAGE_UUID } from './constants/uuid'

export const rankingAuctionRoute: RouteItem = {
  title: '竞拍（排名）',
  hideChildrenInMenu: true,
  uuid: RANKING_AUCTION_LIST_PAGE_UUID,
  children: [
    {
      title: '竞拍（排名）列表',
      path: RANKING_AUCTION_LIST_PAGE_PATH,
      Component: () => import('./List')
    },
    {
      title: '新增竞拍（排名）',
      path: RANKING_AUCTION_CREATE_PAGE_PATH,
      Component: () => import('./Create')
    }
  ]
}
